import { render } from "./Upload.vue?vue&type=template&id=1c7bfe2f"
import script from "./Upload.vue?vue&type=script&lang=js"
export * from "./Upload.vue?vue&type=script&lang=js"

import "./Upload.vue?vue&type=style&index=0&id=1c7bfe2f&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__